import { Outlet } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { Button } from "@/components/Ui";
import { AdminNav } from "@/components/AdminNav";

export default function Manage() {
	const { session, signOut } = useAuth();
	const adminEmail = session?.data?.user?.email;

	return (
		<div style={{ display: "flex", flexDirection: "column", minHeight: "100dvh" }}>
			<div
				style={{
					padding: "1rem 1.25rem",
					maxWidth: 960,
					width: "100%",
					margin: "0 auto",
					flex: 1,
					paddingBottom: "max(5rem, calc(5rem + env(safe-area-inset-bottom)))",
				}}
			>
				<div
					style={{
						display: "flex",
						alignItems: "center",
						justifyContent: "space-between",
						marginBottom: "1rem",
						paddingBottom: "0.75rem",
						borderBottom: "1px solid var(--color-border)",
					}}
				>
					<div>
						<h1 style={{ fontSize: "1.2rem", fontWeight: 800, margin: 0 }}>
							Yayy! Admin
						</h1>
						<p
							style={{
								fontSize: "0.75rem",
								color: "var(--color-muted)",
								margin: "0.15rem 0 0",
							}}
						>
							{adminEmail}
						</p>
					</div>
					<Button
						variant="ghost"
						onClick={() => signOut()}
						style={{ fontSize: "0.78rem", padding: "0.35rem 0.7rem" }}
					>
						Keluar
					</Button>
				</div>

				<Outlet />
			</div>
			<AdminNav />
		</div>
	);
}
